import React from 'react';

const Skeleton = () => {
    return (
        <div className="opr-skeleton" style={{width:"100%"}}>
                <div className="opr-line"></div>
                <div className="opr-line"></div>
                <div className="opr-line w40"></div>
                <div className="opr-line"></div>
                <div className="opr-line"></div>
                <div className="opr-line w75"></div>
                <div className="opr-line"></div>
                <div className="opr-line w50"></div>
              </div>
    );
};

export default Skeleton;